import React, { useEffect, useState } from "react";
import { adminDashboard } from "../../lib/api";
import AircraftLookup from "./AircraftLookup";

const INR = (n) => "\u20B9" + (n || 0).toLocaleString("en-IN");

export default function AdminDashboard() {
  const [d, setD] = useState(null);
  useEffect(() => { adminDashboard().then(setD).catch(() => setD({})); }, []);
  if (!d) return <p className="adm-sub">Loading…</p>;
  return (
    <div>
      <h1 className="adm-h1">Dashboard</h1>
      <p className="adm-sub">An overview of your charter enquiries and commission.</p>
      <div className="cards">
        <div className="kpi"><div className="v">{d.leads_month || 0}</div><div className="l">Leads this month</div></div>
        <div className="kpi"><div className="v">{d.conversion || 0}%</div><div className="l">Conversion rate</div></div>
        <div className="kpi"><div className="v">{d.confirmed || 0}</div><div className="l">Confirmed trips</div></div>
        <div className="kpi"><div className="v">{INR(d.commission)}</div><div className="l">Total commission</div></div>
        <div className="kpi"><div className="v">{d.leads_total || 0}</div><div className="l">Total leads</div></div>
      </div>
      <AircraftLookup />
      <div className="adm-grid2">
        <div className="panel">
          <h3>Popular routes</h3>
          {(d.popular_routes || []).length ? (
            <table className="tbl"><tbody>{d.popular_routes.map((r) => (<tr key={r.route} style={{ cursor: "default" }}><td>{r.route}</td><td style={{ textAlign: "right", fontWeight: 800 }}>{r.count}</td></tr>))}</tbody></table>
          ) : <p className="adm-sub">No leads yet. Requests from the website will appear here.</p>}
        </div>
        <div className="panel">
          <h3>Leads by status</h3>
          <table className="tbl"><tbody>{Object.entries(d.status_breakdown || {}).map(([k, v]) => (<tr key={k} style={{ cursor: "default" }}><td><span className={"pill " + k}>{k}</span></td><td style={{ textAlign: "right", fontWeight: 800 }}>{v}</td></tr>))}</tbody></table>
        </div>
      </div>
    </div>
  );
}
